import { Component } from '@angular/core';

@Component({
    selector: 'app-supervisor-canje-detalle',
    templateUrl: './supervisor-canje-detalle.component.html',
    styleUrls: ['./supervisor-canje-detalle.component.scss'],

})
export class SupervisorCanjeDetalleComponent {

}